import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../constants/Colors";
import useIsMobile from "../../hooks/useIsMobile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface OnboardingStepProps {
  stepNumber: number;
  title: string;
  isCompleted: boolean;
  children?: React.ReactNode;
}

const OnboardingStep = ({ stepNumber, title, isCompleted, children }: OnboardingStepProps) => {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ marginBottom: isMobile ? "24px" : "32px" }}>
      <Box sx={{ 
        display: "flex", 
        alignItems: "center", 
        marginBottom: isMobile ? "12px" : "16px",
        flexWrap: isMobile ? "wrap" : "nowrap"
      }}>
        <Box
          sx={{
            width: isMobile ? "28px" : "32px",
            height: isMobile ? "28px" : "32px",
            borderRadius: "50%",
            backgroundColor: isCompleted ? colors.blue : "#e0e0e0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: isMobile ? "8px" : "12px",
            color: "white",
            fontWeight: "bold",
            fontSize: isMobile ? "14px" : "16px",
            flexShrink: 0,
          }}
        >
          {isCompleted ? <CheckCircleIcon sx={{ fontSize: isMobile ? "18px" : "20px" }} /> : stepNumber}
        </Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: isCompleted ? colors.blue : "#22303E",
            fontSize: isMobile ? "16px" : "18px",
            lineHeight: isMobile ? "1.3" : "1.4",
          }}
        >
          {title}
        </Typography>
      </Box>
      {children}
    </Box>
  );
};

export default OnboardingStep; 